export enum EEntityType {
  DOCUMENT_CONSTRUCTOR = "DOCUMENT_CONSTRUCTOR",
  DOCUMENT_TEMPLATE = "DOCUMENT_TEMPLATE",
  COMPANY = "COMPANY",
  USER = "USER",
}

export enum EApprovalActionType {
  CREATE = "CREATE",
  UPDATE = "UPDATE",
  DEACTIVATE = "DEACTIVATE",
}

export enum EApprovalStatus {
  WAITING = "WAITING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
}

export enum EEntityScope {
  PRIVATE = "PRIVATE",
  UNIT = "UNIT",
  MULTI_UNIT = "MULTI_UNIT",
  ALL = "ALL",
}

export interface IEntityApprovalRequest {
  id: string;
  entityType: EEntityType;
  entityId: string | null;
  actionType: EApprovalActionType;
  status: EApprovalStatus;
  payload: Record<string, unknown>;
  previousPayload?: Record<string, unknown> | null;
  requesterId: string;
  requesterName?: string | null;
  coordinatorId: string | null;
  coordinatorName?: string | null;
  approvedById: string | null;
  approvedByName?: string | null;
  directorateId: string;
  directorateName?: string | null;
  rejectReason: string | null;
}

export interface IRejectRequest {
  reason?: string | null;
}

export function isEntityApprovalId(value: unknown): value is string {
  return (
    typeof value === "string" &&
    (/^[0-9A-Za-z]{16}$/.test(value) ||
      (/^[0-9]{1,15}$/.test(value) && Number(value) > 0))
  );
}

export default IEntityApprovalRequest;
